module.exports = __webpack_public_path__ + "img/left2.f11d2132.png";